type MatchItem = {
  type: 'match' | 'nonMatch';
  value: string;
};

const stringToRegexp = (query: RegExp | string): RegExp | string => {
  if (typeof query !== 'string') {
    return query;
  }

  try {
    // Remove backspaces when creating regular expression
    return new RegExp(query.replace('\\', ''), 'gi');
  } catch {
    // If the user sends something that is not a valid regexp (ex. not matching
    // paranteses: "XX)"), just use the string as is.
    return query;
  }
};

export const findMatches = <T>(
  text: T,
  query: RegExp | string | undefined,
): {original: T | undefined; matches: MatchItem[] | undefined} => {
  if (!query || !text || typeof text !== 'string') {
    return {original: text, matches: undefined};
  }

  const regex = stringToRegexp(query);
  const modifiedText = text.replace(regex, match => `<!>@@${match}<!>`);
  if (modifiedText.length === text.length) {
    return {original: text, matches: undefined};
  }

  const parts = modifiedText.split('<!>');
  const matches = parts
    .map<MatchItem>(part =>
      part.startsWith('@@')
        ? {type: 'match', value: part.substring(2)}
        : {type: 'nonMatch', value: part},
    )
    .filter(m => m.value.length > 0);

  return {original: undefined, matches};
};
